const initCustomAccordionColBlog = () => {
    if (window.innerWidth >= 700) {
        return;
    }

    const containers = document.querySelectorAll('.custom-accordion-col-blog-container');
    if (containers.length === 0) return;

    containers.forEach(container => {
        const {
            collectionHandles,
            articleId,
            shopDomain,
            viewCollectionText,
            readMoreText,
            languageCode
        } = container.dataset;

        if (!shopDomain || (!collectionHandles && !articleId) || !languageCode) {
            return;
        }

        const storefrontAccessToken = 'a3bbfffa7bd9c12567ca998d55f71454';
        const apiVersion = '2025-10';
        const storefrontApiUrl = `https://${shopDomain}/api/${apiVersion}/graphql.json`;

        const articleGid = articleId ? `gid://shopify/Article/${articleId.trim()}` : null;
        const handles = collectionHandles ? collectionHandles.split(',').filter(h => h.trim()) : [];

        let finalQuery = 'query getCollectionsAndArticle';
        let queryParts = [];
        let variableDefinitions = ['$language: LanguageCode!'];
        let variables = { language: languageCode.toUpperCase() };

        if (handles.length > 0) {
            handles.forEach((handle, index) => {
                const alias = `collection${index}`;
                const varName = `handle${index}`;
                variableDefinitions.push(`$${varName}: String!`);
                queryParts.push(`
                    ${alias}: collection(handle: $${varName}) {
                        title
                        description
                        onlineStoreUrl
                        image { url altText width height }
                    }
                `);
                variables[varName] = handle;
            });
        }

        if (articleGid) {
            variableDefinitions.push('$articleId: ID!');
            queryParts.push(`
                article: node(id: $articleId) {
                    ... on Article {
                        title
                        excerpt(truncateAt: 200)
                        onlineStoreUrl
                        image { url altText width height }
                    }
                }
            `);
            variables['articleId'] = articleGid;
        }

        if (queryParts.length === 0) {
            return;
        }

        finalQuery += `(${variableDefinitions.join(', ')}) @inContext(language: $language) { ${queryParts.join(' ')} }`;

        const fetchContent = async () => {
            try {
                const response = await fetch(storefrontApiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                    },
                    body: JSON.stringify({
                        query: finalQuery,
                        variables: variables,
                    }),
                });

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const { data } = await response.json();
                let contentHtml = '';

                if (handles.length > 0) {
                    handles.forEach((handle, index) => {
                        const collection = data[`collection${index}`];
                        if (collection) {
                            const imageHtml = collection.image
                                ? `<div class="custom-tabs-tab-image"><img src="${collection.image.url}" alt="${collection.image.altText || ''}" width="${collection.image.width}" height="${collection.image.height}" loading="lazy"></div>`
                                : '';
                            contentHtml += `
                                <div class="prose custom-tabs-tab mobile">
                                    <div class="custom-tabs-tab-description">
                                        <h3 class="custom-tabs-tab-subtitle">${collection.title}</h3>
                                        <div class="custom-tabs-tab-text">${collection.description || ''}</div>
                                        <div class="custom-tabs-tab-button"><a href="${collection.onlineStoreUrl}" class="button">${viewCollectionText}</a></div>
                                    </div>
                                    ${imageHtml}
                                </div>
                            `;
                        }
                    });
                }

                const { article } = data;
                if (article) {
                    const imageHtml = article.image
                        ? `<div class="custom-tabs-tab-image"><img src="${article.image.url}" alt="${article.image.altText || ''}" width="${article.image.width}" height="${article.image.height}" loading="lazy"></div>`
                        : '';
                    const excerptHtml = article.excerpt ? `<div class="custom-tabs-tab-text">${article.excerpt}</div>` : '';
                    contentHtml += `
                        <div class="prose custom-tabs-tab mobile">
                            <div class="custom-tabs-tab-description">
                                <h3 class="custom-tabs-tab-subtitle">${article.title}</h3>
                                ${excerptHtml}
                                <div class="custom-tabs-tab-button"><a href="${article.onlineStoreUrl}" class="button">${readMoreText}</a></div>
                            </div>
                            ${imageHtml}
                        </div>
                    `;
                }

                container.innerHTML = contentHtml;

            } catch (error) {
                console.error('Error fetching collection/blog content:', error);
                container.innerHTML = '<p>Error loading content.</p>';
            }
        };

        fetchContent();
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomAccordionColBlog);
} else {
    initCustomAccordionColBlog();
}
